<template>
    <div class="menu-div">
        <div class="text-align m10">
            <img src="../../static/images/u34.png" class="img1">
            <span style="font-size: 20px;" class="font-weight">{{ $t('lang.Product') }}</span>
        </div>
        <a-menu mode="vertical">
            <a-menu-item v-for="(item) in navData" :key=item.id @click="handleClick(item.id)">
                <a-row>
                    <a-col :span="5">
                        <img src="../../static/images/u45.png" class="img2">
                    </a-col>
                    <a-col :span="19" class="wrap">
                        <div id="one">
                            {{ item.name }}
                        </div>
                    </a-col>
                </a-row>
            </a-menu-item>
        </a-menu>
    </div>
</template>

<script>
// import navData from '../../static/data/LeftNav.json';
import {get} from "@/utils";

export default {
    name: "nav",
    data() {
        return {
            navData: null,
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            get('product/getProductCategoryList', {}).then(res => {
                this.navData = res.data.list;
            }).catch(() => {
            })
        },
        handleClick(e) {
            // this.$router.push({path: '/goods', query: {goodsType: e}})
            this.$router.push({path: '/goods/' + e + '.html'})
        },
    },
}
</script>

<style scoped>

.wrap {
    display: table;
}

#one {
    cursor: pointer;
    width: 200px;
    height: 66px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
}

.menu-div {
    border: 1px solid #0099FF;
    width: 240px;
    /*height: 500px;*/
    padding: 0 10px;
}

.img1 {
    width: 50px;
    margin-right: 20px;
}

.img2 {
    margin-top: 12px;
    width: 40px;
    margin-right: 10px;
}

.m10 {
    margin: 20px 0;
}

.ant-menu-vertical .ant-menu-item:not(:last-child) {
    margin-bottom: 0 !important;
}

.ant-menu-submenu >>> .ant-menu-submenu-title {
    margin: 0 !important;
    height: 60px !important;
    line-height: 60px !important;
    font-size: 18px !important;
}

.ant-menu-inline, .ant-menu-vertical, .ant-menu-vertical-left {
    border: none;
}

.ant-menu-vertical .ant-menu-item {
    margin-top: 0 !important;
    height: 87px !important;
    line-height: 40px !important;
    padding: 1px 0;
    overflow: hidden;
    font-size: 16px;
    text-overflow: ellipsis;
    border-top: 1px solid;
}
</style>
